export default {
  // Header
  'nav.home': 'Home',
  'nav.about': 'About',
  'nav.services': 'Services',
  'nav.products': 'Products',
  'nav.contact': 'Contact',
  'header.getQuote': 'Get Quote',
  
  // Hero
  'hero.title': 'Premium Truck & Trailer Spare Parts',
  'hero.subtitle': 'Your trusted partner for high-quality commercial vehicle parts and accessories. Fast delivery, competitive prices, and expert support.',
  'hero.shopNow': 'Shop Now',
  'hero.learnMore': 'Learn More',
  
  // About
  'about.title': 'About GB Group',
  'about.description': 'GB Group is a leading supplier of high-quality truck and trailer spare parts in Turkmenistan. With over 15 years of experience, we provide reliable automotive components and exceptional service to our customers across Central Asia. As official dealers of world-renowned brands, we ensure authenticity and quality in every product we deliver.',
  'about.experience': 'Years of Experience',
  'about.products': 'Quality Products',
  'about.customers': 'Satisfied Customers',
  'about.countries': 'Countries Served',
  'about.marketsServed': 'Markets Served',
  'about.supportAvailable': 'Support Available',
  'about.ourStory': 'Our Story',
  'about.storyP1': 'GB Group Truck\'s & Trailer\'s Spare Parts and Logistics was established in 2004 with a simple mission: to provide reliable, high-quality spare parts for the growing transportation industry in Turkmenistan.',
  'about.storyP2': 'Over the past 20 years, we have grown from a small local business to a leading provider serving 16 markets across Turkmenistan. Our main operations are based in Ashgabat city, where we maintain our primary warehouse and logistics center.',
  'about.storyP3': 'We specialize in providing our customers with reliable spare parts that keep their fleets running efficiently. Our commitment to quality and customer service has made us the preferred choice for transportation companies throughout the region.',
  'about.contactUsToday': 'Contact Us Today',
  'about.ourJourney': 'Our Journey',
  'about.journeySubtitle': 'Two decades of growth, innovation, and commitment to serving Turkmenistan\'s transportation industry',
  'about.year2004': 'Company Founded',
  'about.year2004Desc': 'Started our journey in truck and trailer spare parts business in Turkmenistan',
  'about.year2008': 'Market Expansion',
  'about.year2008Desc': 'Expanded operations to serve multiple regions across Turkmenistan',
  'about.year2015': '16 Markets Reached',
  'about.year2015Desc': 'Successfully established presence in 16 markets throughout Turkmenistan',
  'about.year2024': 'Leading Provider',
  'about.year2024Desc': 'Became the trusted leader in reliable spare parts and logistics solutions',
  'about.ourMission': 'Our Mission',
  'about.missionDesc': 'To be Turkmenistan\'s most trusted provider of truck and trailer spare parts, delivering reliable products and exceptional logistics services that keep our customers\' fleets running smoothly.',
  'about.qualityAssurance': 'Quality Assurance',
  'about.qualityAssuranceDesc': 'Every spare part meets the highest quality standards for reliability and durability.',
  'about.fastLogistics': 'Fast Logistics',
  'about.fastLogisticsDesc': 'Efficient delivery network covering all 16 markets across Turkmenistan.',
  'about.expertSupport': 'Expert Support',
  'about.expertSupportDesc': 'Knowledgeable team providing technical assistance and product guidance.',
  'about.ourLocations': 'Our Locations',
  'about.locationsSubtitle': 'Serving 16 markets across Turkmenistan with our main headquarters in Ashgabat',
  'about.mainHeadquarters': 'Main Headquarters - Ashgabat',
  'about.phone': 'Phone',
  'about.marketsWeServe': 'Markets We Serve',
  'about.marketsDesc': 'We proudly serve 16 markets across Turkmenistan, providing reliable spare parts and logistics solutions to transportation companies in every region. Our extensive network ensures fast delivery and local support wherever you are.',
  
  // Services
  'services.title': 'Our Services',
  'services.subtitle': 'Comprehensive solutions for all your truck and trailer needs',
  'services.wholesale': 'Wholesale Distribution',
  'services.wholesaleDesc': 'Bulk orders with competitive pricing for dealers and workshops',
  'services.delivery': 'Fast Delivery',
  'services.deliveryDesc': 'Quick and reliable shipping to your location',
  'services.support': 'Technical Support',
  'services.supportDesc': '24/7 expert assistance for part selection and installation',
  'services.warranty': 'Quality Warranty',
  'services.warrantyDesc': 'All products backed by manufacturer warranties',
  'services.truckParts': 'Truck Spare Parts',
  'services.truckPartsDesc': 'Comprehensive range of genuine and aftermarket spare parts for all major truck brands including Mercedes-Benz, Volvo, Scania, MAN, DAF, and Iveco.',
  'services.trailerParts': 'Trailer Spare Parts',
  'services.trailerPartsDesc': 'Complete selection of trailer parts and accessories for semi-trailers, flatbeds, tankers, and specialized trailers from leading manufacturers.',
  'services.customOrders': 'Custom Orders',
  'services.customOrdersDesc': 'Special order service for hard-to-find parts and bulk orders with competitive pricing for fleet operators and repair shops.',
  'services.whatWeOffer': 'What We Offer',
  'services.whatWeOfferDesc': 'Complete range of services designed to keep your trucks and trailers running smoothly with minimal downtime',
  'services.brandsWeSupport': 'Brands We Support',
  'services.brandsDesc': 'We stock parts for all major truck and trailer manufacturers, ensuring compatibility and quality',
  'services.howItWorks': 'How It Works',
  'services.howItWorksDesc': 'Simple and efficient process to get the parts you need quickly and hassle-free',
  'services.whyChoose': 'Why Choose GB Group?',
  'services.whyChooseDesc': 'Your trusted partner for truck and trailer spare parts in Turkmenistan',
  'services.yearsExp': '20+ Years',
  'services.yearsExpDesc': 'Experience in automotive spare parts industry',
  'services.partsStock': '500K+',
  'services.partsStockDesc': 'Parts available in stock ready for delivery',
  'services.satisfiedCustomers': '300K+',
  'services.satisfiedCustomersDesc': 'Satisfied customers across Turkmenistan',
  'services.support247': '24/7',
  'services.support247Desc': 'Customer support available anytime',
  'services.needParts': 'Need Parts or Have Questions?',
  'services.needPartsDesc': 'Our team is ready to assist you with expert advice and fast service. Contact us today!',
  'services.contactUs': 'Contact Us',
  'services.call': 'Call +993 65049474',
  'services.feature1': 'Engine components and parts',
  'services.feature2': 'Transmission systems',
  'services.feature3': 'Brake systems and components',
  'services.feature4': 'Suspension parts',
  'services.feature5': 'Electrical components',
  'services.feature6': 'Filters and maintenance items',
  'services.feature7': 'Axles and suspension systems',
  'services.feature8': 'Landing gear and kingpins',
  'services.feature9': 'Brake chambers and slack adjusters',
  'services.feature10': 'Lighting and electrical systems',
  'services.feature11': 'Coupling systems',
  'services.feature12': 'Body parts and accessories',
  'services.feature13': 'Part identification service',
  'services.feature14': 'Technical specifications',
  'services.feature15': 'Installation guidance',
  'services.feature16': 'Compatibility verification',
  'services.feature17': 'Maintenance recommendations',
  'services.feature18': 'Troubleshooting support',
  'services.feature19': 'Same-day dispatch available',
  'services.feature20': 'Express delivery options',
  'services.feature21': 'Secure packaging',
  'services.feature22': 'Order tracking',
  'services.feature23': 'Local and international shipping',
  'services.feature24': 'Flexible delivery schedules',
  'services.feature25': 'Genuine OEM parts',
  'services.feature26': 'Certified aftermarket brands',
  'services.feature27': 'Quality inspection process',
  'services.feature28': 'Warranty coverage',
  'services.feature29': 'Return and exchange policy',
  'services.feature30': 'Performance guarantee',
  'services.feature31': 'Sourcing rare parts',
  'services.feature32': 'Bulk order discounts',
  'services.feature33': 'Fleet management solutions',
  'services.feature34': 'Customized pricing',
  'services.feature35': 'Priority handling',
  'services.feature36': 'Dedicated account manager',
  'services.step1': 'Contact Us',
  'services.step1Desc': 'Reach out via phone, email, or visit our office with your part requirements or vehicle details.',
  'services.step2': 'Part Identification',
  'services.step2Desc': 'Our experts will help identify the exact parts you need using VIN numbers, part codes, or vehicle specifications.',
  'services.step3': 'Quote & Availability',
  'services.step3Desc': 'Receive a detailed quote with pricing, availability, and estimated delivery time for your required parts.',
  'services.step4': 'Order Confirmation',
  'services.step4Desc': 'Confirm your order and make payment through our secure payment options including bank transfer and cash.',
  'services.step5': 'Delivery',
  'services.step5Desc': 'Your parts are carefully packaged and dispatched with tracking information provided for your convenience.',
  'services.step6': 'After-Sales Support',
  'services.step6Desc': 'Enjoy our comprehensive after-sales support including installation guidance and warranty coverage.',
  
  // Products
  'products.title': 'Featured Products',
  'products.viewAll': 'View All Products',
  'products.addToCart': 'Add to Cart',
  'products.inStock': 'In Stock',
  'products.new': 'New',
  'products.sale': 'Sale',
  'products.filters': 'Filters',
  'products.category': 'Category',
  'products.allCategories': 'All Categories',
  'products.priceRange': 'Price Range',
  'products.brand': 'Brand',
  'products.availability': 'Availability',
  'products.inStockOnly': 'In Stock Only',
  'products.sortBy': 'Sort By',
  'products.featured': 'Featured',
  'products.priceLowHigh': 'Price: Low to High',
  'products.priceHighLow': 'Price: High to Low',
  'products.newest': 'Newest',
  'products.pageTitle': 'Our Products',
  'products.pageSubtitle': 'Browse our extensive catalog of premium truck and trailer spare parts',
  'products.searchPlaceholder': 'Search parts...',
  'products.searchProducts': 'Search Products',
  'products.categories': 'Categories',
  'products.engineParts': 'Engine Parts',
  'products.brakingSystem': 'Braking System',
  'products.suspension': 'Suspension',
  'products.lighting': 'Lighting',
  'products.trailerParts': 'Trailer Parts',
  'products.productsFound': 'products found',
  'products.nameAZ': 'Name A-Z',
  'products.highestRated': 'Highest Rated',
  'products.outOfStock': 'Out of Stock',
  'products.requestQuote': 'Request Quote',
  'products.notifyMe': 'Notify Me',
  'products.reviews': 'reviews',
  'products.noResults': 'No products found',
  'products.noResultsDesc': 'Try adjusting your filters or search terms',
  'products.loadMore': 'Load More Products',
  'products.clearFilters': 'Clear All Filters',
  'products.gbGroupCatalogue': 'GB Group Catalogue',
  'products.ownBrandBadge': 'GB Group Own Brand',
  'products.showcaseTitle1': 'Truck Spare Parts',
  'products.showcaseTitle2': 'Disk Brake Pads',
  'products.showcaseDesc': 'Our own branded line of high-performance disk brake pads engineered specifically for European trucks. Designed to OEM standards for Mercedes-Benz, Volvo, Scania, MAN, DAF and Iveco.',
  'products.badgeOEM': 'OEM Quality',
  'products.badgeEuroTrucks': 'European Trucks',
  'products.badgeLongLasting': 'Long Lasting',
  'products.badgeInStock': 'In Stock',
  'products.fullCatalogue': 'Full Catalogue',
  'products.browseAllParts': 'Browse All Parts',
  'products.cantFind': "Can't Find What You're Looking For?",
  'products.cantFindDesc': "Our team can source any truck or trailer spare part. Contact us and we'll find it for you.",
  'products.requestCustomQuote': 'Request a Custom Quote',
  'products.handpickedSelection': 'Handpicked Selection',
  'products.featuredProducts': 'Featured Products',
  'products.featuredBadge': 'Featured',
  'products.genuineTagline': 'Genuine Parts, Trusted Performance',
  'products.cat.engine': 'Engine',
  'products.cat.braking': 'Braking',
  'products.cat.suspension': 'Suspension',
  'products.cat.lighting': 'Lighting',
  'products.cat.trailer': 'Trailer',
  
  // Contact
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Get in touch with our team for inquiries and support',
  'contact.name': 'Your Name',
  'contact.email': 'Email Address',
  'contact.phone': 'Phone Number',
  'contact.message': 'Your Message',
  'contact.send': 'Send Message',
  'contact.info': 'Contact Information',
  'contact.address': 'Address',
  'contact.addressValue': '123 Industrial Road, Ashgabat, Turkmenistan',
  'contact.phoneValue': '+993 12 345678',
  'contact.emailValue': 'info@gbgroup.tm',
  'contact.hours': 'Business Hours',
  'contact.hoursValue': 'Mon-Fri: 8:00 AM - 6:00 PM',
  
  // Footer
  'footer.description': 'Your trusted partner for premium truck and trailer spare parts.',
  'footer.quickLinks': 'Quick Links',
  'footer.categories': 'Categories',
  'footer.support': 'Support',
  'footer.faq': 'FAQ',
  'footer.shipping': 'Shipping Info',
  'footer.returns': 'Returns',
  'footer.newsletter': 'Newsletter',
  'footer.newsletterDesc': 'Subscribe to get special offers and updates',
  'footer.subscribe': 'Subscribe',
  'footer.rights': 'All rights reserved.',
  
  // Common
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.clear': 'Clear',
  'common.apply': 'Apply',
  
  // Brands
  'brands.badge': 'Official Dealer',
  'brands.title': 'Trusted Brand Partners',
  'brands.subtitle': 'We are proud to be an official dealer of world-renowned brands, ensuring you receive only genuine, high-quality parts.',
  'brands.guarantee': 'All products come with manufacturer warranty and authenticity guarantee',
};

export const common = {
  about: {
    title: 'About GB Group',
    description: 'GB Group is a leading supplier of high-quality truck and trailer spare parts in Turkmenistan. With over 15 years of experience, we provide reliable automotive components and exceptional service to our customers across Central Asia. As official dealers of world-renowned brands, we ensure authenticity and quality in every product we deliver.',
    experience: 'Years of Experience',
    products: 'Quality Products',
    customers: 'Satisfied Customers',
    countries: 'Countries Served',
  },
  brands: {
    title: 'Official Dealer of Trusted Brands',
    subtitle: 'We are proud to be the official dealer of these world-renowned automotive brands',
  },
};